export const test_jwt = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJtYWlsIjoiYi5vc3RlbmRvcmZAdWtlLmRlIiwibG9nZ2VkX2luIjp0cnVlLCJpYXQiOjE2ODI5NTQxOTUsInJvbGUiOiJhZG1pbiJ9.TtbHE2TLXq-T6lZf3UvraAcDD__NE6C5jxY_aALOR_M";
export const test_requestor_mail = "b.ostendorf@uke.de";
export const test_proposal = {
  author: "b.ostendorf@uke.de",
  id: "277",
  title: "test titel _ new",
  lastname: "isdcahwr",
}
